import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnDestroy } from '@angular/core';
import { CdsProgressModule } from '@cds/ng-web-components/progress';
import { Subscription } from 'rxjs';
import { LoaderService, LoaderType } from '../../../core/services/loader.service';

@Component({
  selector: 'app-loader',
  imports: [CommonModule, CdsProgressModule],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LoaderComponent implements OnDestroy {
  isLoading: boolean = false;
  loaderType: LoaderType = 'NONE';
  subscription: Subscription;
  appearAsModal:boolean = false;
  loaderText!:string;
  diameter:number = 60;

  constructor(private loaderService: LoaderService) {
    this.subscription = this.loaderService.isLoading.subscribe((loaderConfig) => {
      this.isLoading = loaderConfig._isLoading || false;
      this.loaderType = loaderConfig.loaderType;
      this.appearAsModal = loaderConfig.appearAsModal as unknown as boolean;
      this.loaderText = loaderConfig.loaderText as unknown as string;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
